<template>
    <div
       class="navContent"
       :loading="loading"
    >
        <van-tabs v-show="dataList.length>0">
            <van-tab v-for="(item, index) in dataList" :title="item.subject_name" :key="index">
                <div v-for="videoItem in item.resources" @click="goPlayVideo(videoItem.id, videoItem.resource_id)" class="list-item">
                    <img :src="videoItem.cover_pic" class="cover-img"/>
                    <div class="video-des">
                        <p class="single-line">{{videoItem.name}}</p>
                        <p class="single-line" style="color: #a2a2a2;font-size: 90%;">上传时间：{{timestampToTime(videoItem.create_time)}}</p>
                        <p class="single-line" style="color: #a2a2a2;font-size: 90%;">{{playNum(videoItem.id)}}次观看</p>
                    </div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import { baseUrl, cd_baseUrl, baseApi2} from '@/assets/js/api';
    import paramsHelper from '@/assets/js/parametersHelper';
    export default {
        name: "SchoolBased",
        data(){
            return{
                loading: false,
                schoolBasedTabs:["语文","数学","英语","物理","化学","生物","政治","历史","地理","其它"],
                dataList: [],
                playNumList: [],
            }
        },
        props: {
            bookId: {
                type: Array,
                default: ()=>[], // 0新增，1修改
            },
            lessonId: {
                type: String,
                default(){
                    return ''
                }
            }
        },
        mounted(){
            this.getList();
        },
        methods:{
            playNum(id) {
                for (let i = 0; i < this.playNumList.length; i++) {
                    if(this.playNumList[i].vedioId === id){
                        return this.playNumList[i].playNum;
                    }
                }
                return 0;
            },
            getList(){
                var that = this;
                that.loading = true;

                this.$axios.get(baseApi2 + '/jwt/resource/upload/getBeikeMp4ByUserBook', {
                    params: {
                        bookIds: that.bookId.join(',')
                    }
                }).then(function (res) {
                        var videoIds = [];
                        var list = res.data.recordset;
                        if(list.length<1){
                            that.$toast('没有配置MP4的校本视频');
                        }
                        var tempResArr = [];
                        for (let j = 0; j < that.schoolBasedTabs.length; j++) {
                            for (let i = 0; i < list.length; i++) {
                                if(that.schoolBasedTabs[j] === list[i].subject_name){
                                    let resources = list[i].resources
                                    tempResArr.push(list.splice(i,1)[0]);
                                    for (let k = 0; k < resources.length; k++) {
                                        videoIds.push(resources[k].id);
                                    }
                                    i--;
                                }
                            }
                        }

                        // 其他类
                        while(list.length>0){
                            let resources = list[0].resources
                            tempResArr.push(list.shift());
                            for (let k = 0; k < resources.length; k++) {
                                videoIds.push(resources[k].id);
                            }
                        }

                        that.getPlayNum(videoIds, tempResArr);
                    that.loading = false;
                }).catch(function (err) {
                    // that.$toast(err.errmsg || err.data.errmsg);
                });
            },
            getPlayNum(videoIds, tempResArr){
                var that = this;
                this.$axios.post(cd_baseUrl + '/microClassCustom/link/getVedioPlayNum', videoIds).then(function (res) {
                    if (res && res.data.errcode === 0) {
                        that.playNumList = res.data.data.list;
                        that.dataList = tempResArr;
                    } else {
                        that.$toast(res.data.errmsg)
                    }
                    that.loading = false;
                }).catch(function (err) {
                    that.$toast(err.errmsg || err.data.errmsg);
                });
            },
            timestampToTime (timestamp) {
                var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                var D = date.getDate() + ' ';
                // var h = date.getHours() + ':';
                // var m = date.getMinutes() + ':';
                // var s = date.getSeconds();
                return Y+M+D;
            },
            goPlayVideo (videoId, resource_id) {
                this.$router.push({
                    name: 'Video',
                    query: { params: paramsHelper.encode({ videoId }), resourceId: resource_id, lessonId: this.lessonId || '' }
                })
            },
        }

    }
</script>

<style scoped>
    .cover-img{
        max-width: 23%;
        width: 23%;
        max-height: 150px;
        display: inline-block;
        margin-right: 2%;
    }
    .video-des{
        display: inline-block;width: 75%;
    }
    .list-item{
        border-bottom: 1px solid #e8f2ec;
        padding: 10px 20px;
        display: flex;
        align-items: center;
    }
    .single-line{
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
        margin: 5px;
    }
</style>